import api from "./api";
import type {
  MaturityReport, SnapshotPoint, MonthlyReportItem,
  CatalogObligation, CatalogObligationInput, ObligationStatus, ComplianceOverview,
} from "@/types/complianceMaturity";

class ComplianceMaturityService {
  private base = "/compliance-maturity";

  // ----- 기업 관리자: 진단·점수 리포트 -----
  async getReport(): Promise<MaturityReport> {
    const r = await api.get(this.base);
    return r.data;
  }
  async setStatus(obligationId: number, data: { status: ObligationStatus; note?: string }): Promise<void> {
    await api.put(`${this.base}/obligations/${obligationId}`, data);
  }
  async pendingCount(): Promise<{ count: number }> {
    const r = await api.get(`${this.base}/pending-count`);
    return r.data;
  }

  // ----- 점수 추이 + 정기보고서 보관함 -----
  async history(): Promise<SnapshotPoint[]> {
    const r = await api.get(`${this.base}/history`);
    return r.data;
  }
  async listReports(): Promise<MonthlyReportItem[]> {
    const r = await api.get(`${this.base}/reports`);
    return r.data;
  }
  async getReportDetail(id: number): Promise<any> {
    const r = await api.get(`${this.base}/reports/${id}`);
    return r.data;
  }
  async downloadReportPdf(id: number, label: string): Promise<void> {
    const r = await api.get(`${this.base}/reports/${id}/pdf`, { responseType: "blob" });
    const url = window.URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = `compliance_report_${label}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }
  async runReport(): Promise<{ snapshot_id: number; score: number; emailed: number; pdf_saved: boolean }> {
    const r = await api.post(`${this.base}/reports/run`);
    return r.data;
  }

  // ----- 본사 슈퍼관리자: 전사 현황·랭킹 -----
  async overview(): Promise<ComplianceOverview> {
    const r = await api.get(`${this.base}/overview`);
    return r.data;
  }
  async overviewCompany(companyId: string): Promise<MaturityReport & { company_name: string }> {
    const r = await api.get(`${this.base}/overview/${companyId}`);
    return r.data;
  }

  // ----- 본사 슈퍼관리자: 카탈로그 CRUD (+ 가중치) -----
  async catalogList(includeInactive = false): Promise<CatalogObligation[]> {
    const r = await api.get(`${this.base}/catalog`, { params: { include_inactive: includeInactive } });
    return r.data;
  }
  async catalogCreate(data: CatalogObligationInput & { code: string }): Promise<CatalogObligation> {
    const r = await api.post(`${this.base}/catalog`, data);
    return r.data;
  }
  async catalogUpdate(id: number, data: Partial<CatalogObligationInput>): Promise<CatalogObligation> {
    const r = await api.put(`${this.base}/catalog/${id}`, data);
    return r.data;
  }
  async catalogDelete(id: number): Promise<void> {
    await api.delete(`${this.base}/catalog/${id}`);
  }
  async catalogSync(): Promise<{ created: number }> {
    const r = await api.post(`${this.base}/catalog/sync`);
    return r.data;
  }
}

const complianceMaturityService = new ComplianceMaturityService();
export default complianceMaturityService;
